import React, { useState } from "react";
import { FaSpinner, FaRobot, FaCheckCircle } from "react-icons/fa";
import { motion } from "framer-motion";

const CaptchaModal = ({ onVerify }) => {
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(false);
  const handleCheck = () => {
    if (loading || checking) return;

    setChecking(true);
    setTimeout(() => {
      setChecking(false);
      setChecked(true);
    }, 2000);
  };

  const handleVerify = () => {
    if (!checked) return;
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
      onVerify();
    }, 2000);
  };

  return (
    <div className="w-full h-full flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        className="bg-gradient-to-br from-[#FAF1E6] to-[#FDFAF6] border border-[#0070a8] rounded-2xl shadow-2xl p-8 w-full max-w-md flex flex-col items-center gap-6 relative"
      >
        {/* Header */}
        <div className="flex items-center gap-3">
          <FaRobot size={28} className="text-[#0070a8] animate-bounce" />
          <h2 className="text-center text-[#0070a8] font-bold text-2xl">
            Verify You're Human
          </h2>
        </div>

        {/* Checkbox */}
        <motion.div
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className={`flex items-center w-full p-4 border-2 rounded-lg cursor-pointer transition-colors ${
            checked
              ? "border-green-500 bg-green-50 shadow-inner"
              : "border-gray-300 hover:border-[#1e8cbf] bg-white"
          }`}
          onClick={handleCheck}
        >
          {/* Spinner or checkbox */}
          {checking ? (
            <FaSpinner className="animate-spin text-[#0070a8] text-2xl ml-1" />
          ) : (
            <input
              type="checkbox"
              checked={checked}
              readOnly
              className="w-6 h-6 text-green-600 accent-green-600 rounded focus:ring-0"
              disabled={loading}
            />
          )}

          <span className="ml-4 text-gray-800 font-semibold text-lg">
            I am not a robot
          </span>
          {checked && !checking && (
            <FaCheckCircle className="ml-auto text-green-600 text-xl animate-pulse" />
          )}
        </motion.div>

        {/* Verify Button */}
        <motion.button
          onClick={handleVerify}
          disabled={!checked || loading}
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          className="w-full bg-gradient-to-r from-[#0070a8] to-[#023955] hover:from-[#1e8cbf] hover:to-[#1674a3] text-white py-3 rounded-lg font-bold flex items-center justify-center gap-3 disabled:opacity-50 transition-all shadow-lg"
        >
          {loading ? (
            <>
              <FaSpinner className="animate-spin text-white text-xl" />
              <span>Verifying...</span>
            </>
          ) : (
            "Verify"
          )}
        </motion.button>

        {/* Footer */}
        <p className="text-sm text-gray-500 mt-2 text-center">
          This helps us prevent spam and automated submissions.
        </p>
      </motion.div>
    </div>
  );
};

export default CaptchaModal;
